module.exports = __webpack_public_path__ + "img/index-solutions-vehicle.9ad88836.png";